<span class="text-color italic text-base" [innerHTML]="systemMessage()"></span>
